import React from 'react'

const basePath = String(process.env.PUBLIC_URL).trim()
const Inicio = React.lazy(() => import('./views/dashboard/Dashboard'))
const DetalleTramite = React.lazy(() => import('./views/tramites/DetalleTramite'))
const Buscador = React.lazy(() => import('./views/buscador/Buscador'))
//const Transparencia = React.lazy(() => import('./views/buscador/Buscador'))
const OrganismoTramites = React.lazy(() => import('./views/buscador/TramitesOrganismos.js'))

/****  Menu ****/
const InformacionFinanzas = React.lazy(() =>
  import('./views/menu/transparencia/InformacionFinanzas'),
)
const ConcursoPublico = React.lazy(() => import('./views/menu/transparencia/ConcursoPublico'))
const Licitaciones = React.lazy(() => import('./views/menu/transparencia/Licitaciones'))
const Estadisticas = React.lazy(() => import('./views/menu/transparencia/Estadisticas'))
const Normativas = React.lazy(() => import('./views/menu/transparencia/Normativas'))
const Nomina = React.lazy(() => import('./views/menu/transparencia/Nomina'))
const EntreriosTransparente = React.lazy(() =>
  import('./views/menu/transparencia/EntreriosTransparente'),
)
const SueldoFuncionarios = React.lazy(() =>
  import('./views/menu/transparencia/SueldosFuncionarios'),
)
const DeclaracionesJuradas = React.lazy(() =>
  import('./views/menu/transparencia/DeclaracionesJuradas'),
)
const InformacionElectoral = React.lazy(() =>
  import('./views/menu/transparencia/InformacionElectoral'),
)
const BalancesGestDisc = React.lazy(() => import('./views/menu/transparencia/BalancesGestDisc'))
const Institucional = React.lazy(() => import('./views/menu/institucional/Institucional'))
const Provincia = React.lazy(() => import('./views/menu/provincia/Provincia'))
const Produccion = React.lazy(() => import('./views/menu/provincia/Produccion'))
const Turismo = React.lazy(() => import('./views/menu/provincia/Turismo'))

const Noticias = React.lazy(() => import('./views/menu/noticias'))
const Noticia = React.lazy(() => import('./views/menu/noticias/Noticia'))
const NoticiaTema = React.lazy(() => import('./views/menu/noticias/Temas'))
const Cronograma = React.lazy(() => import('./views/menu/noticias/CronogramaPagos'))
/****  Fin Menu ****/

/*** Empleado público ***/
const Empleados = React.lazy(() => import('./views/empleado/Empleados'))
const Sistemas = React.lazy(() => import('./views/intranet/Sistemas'))

/*** Consultas boletin ***/
const Boletin = React.lazy(() => import('./views/consultas/Boletin'))

/*** Consultas Incautaciones ***/
const Incautaciones = React.lazy(() => import('./views/consultas/Incautaciones'))

/*** Consultas Licitaciones ***/
const LicitacionesUep = React.lazy(() => import('./views/consultas/LicitacionesUEP'))

/*** Consultas de Variaciones de Costos ***/
const EmpresasInscriptas = React.lazy(() => import('./views/consultas/EmpresasInscriptas'))

/*** Consultas de Coparticipación de Comunas y Municipios ***/
const Coparticipacion = React.lazy(() => import('./views/consultas/Coparticipacion'))

/*** Consultas de Vigencias -Personas Juridicas ***/
const Vigencia = React.lazy(() => import('./views/consultas/Vigencia'))

/*** Consultas de Generación de Volantes de Pago - ICAB ***/
const Volante = React.lazy(() => import('./views/consultas/Volante'))

/*** Consultas de Carnet de Manipuladores de Alimentos - ICAB ***/
const Manipuladores = React.lazy(() => import('./views/consultas/Manipuladores'))

/*** Consultas de Listado de Establecimientos - ICAB ***/
const Establecimientos = React.lazy(() => import('./views/consultas/Establecimientos'))

/*** Consultas de Listado de Licitaciones para Ministerio de Salud - UCC ***/
const LicitacionesSalud = React.lazy(() => import('./views/consultas/LicitacionesSalud'))

const routes = [
  { to: basePath + '/', exact: true, name: 'Inicio' },
  { to: basePath + '/inicio', exact: true, name: 'Inicio', component: Inicio },
  {
    to: basePath + '/pf/tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/pf/tramite/:id_tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/noticias',
    name: 'Noticias',
    component: Noticias,
    exact: true,
  },
  {
    to: basePath + '/noticias/temas/:tema',
    exact: false,
    name: 'Temas',
    component: NoticiaTema,
  },
  {
    to: basePath + '/noticias/cronograma',
    exact: false,
    name: 'Cronograma',
    component: Cronograma,
  },
  {
    to: basePath + '/noticias/:id',
    exact: false,
    name: 'Noticia',
    component: Noticia,
  },
  {
    to: basePath + '/pf/buscador/tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/pf/buscador/tramite/:id_tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/pf/organismo-tramites/tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/pf/organismo-tramites/tramite/:id_tramite',
    name: 'Trámite o Servicio',
    component: DetalleTramite,
    exact: true,
  },
  {
    to: basePath + '/ps/buscador',
    name: 'Resultado de búsqueda',
    component: Buscador,
    exact: false,
  },
  {
    to: basePath + '/ps/transparencia',
    name: 'Transparencia',
    component: EntreriosTransparente,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/concurso-publico',
    name: 'Concursos',
    component: ConcursoPublico,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/informacion-finanzas',
    name: 'Información Finanzas',
    component: InformacionFinanzas,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/licitaciones',
    name: 'Licitaciones',
    component: Licitaciones,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/estadisticas',
    name: 'Estadísticas',
    component: Estadisticas,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/normativas',
    name: 'Normativas',
    component: Normativas,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/informacion-electoral',
    name: 'Información Electoral',
    component: InformacionElectoral,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/balances-gestion-discursos',
    name: 'Balances de Gestión y Discursos',
    component: BalancesGestDisc,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/nomina',
    name: 'Nómina de Autoridades',
    component: Nomina,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/entre-rios-transparente',
    name: 'Entre Ríos Transparente',
    component: EntreriosTransparente,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/sueldos-funcionarios',
    name: 'Sueldo de Funcionarios',
    component: SueldoFuncionarios,
    exact: true,
  },
  {
    to: basePath + '/ps/transparencia/declaraciones-juradas',
    name: 'Declaraciones Juradas',
    component: DeclaracionesJuradas,
    exact: true,
  },
  {
    to: basePath + '/pf/institucional',
    name: 'Institucional',
    component: Institucional,
    exact: true,
  },
  {
    to: basePath + '/ps/provincia',
    name: 'Provincia',
    component: Provincia,
    exact: true,
  },
  {
    to: basePath + '/ps/provincia/informacion',
    name: 'Información General',
    component: Provincia,
    exact: true,
  },
  {
    to: basePath + '/ps/provincia/produccion',
    name: 'Producción y Comercio',
    component: Produccion,
    exact: true,
  },
  {
    to: basePath + '/ps/provincia/turismo',
    name: 'Turismo',
    component: Turismo,
    exact: true,
  },
  {
    to: basePath + '/pf/empleo-publico',
    name: 'Empleado Público',
    component: Empleados,
    exact: true,
  },
  {
    to: basePath + '/pf/empleo-publico/intranet',
    name: 'Intranet',
    component: Sistemas,
    exact: true,
  },
  {
    to: basePath + '/pf/organismo-tramites',
    name: 'Buscador de Trámites y Servicios por Organismo',
    component: OrganismoTramites,
    exact: true,
  },
  {
    to: basePath + '/consultas/boletin',
    name: 'Consulta de Boletines',
    component: Boletin,
    exact: true,
  },
  {
    to: basePath + '/consultas/incautaciones',
    name: 'Consulta de Incautaciones',
    component: Incautaciones,
    exact: true,
  },
  {
    to: basePath + '/consultas/licitaciones',
    name: 'Consulta de Licitaciones',
    component: LicitacionesUep,
    exact: true,
  },
  {
    to: basePath + '/consultas/empresasinscriptas',
    name: 'Consulta de Variaciones de Costos',
    component: EmpresasInscriptas,
    exact: true,
  },
  {
    to: basePath + '/consultas/coparticipacion',
    name: 'Consulta de Coparticipación',
    component: Coparticipacion,
    exact: true,
  },
  {
    to: basePath + '/consultas/vigencia',
    name: 'Consulta de Vigencia',
    component: Vigencia,
    exact: true,
  },
  {
    to: basePath + '/consultas/volante',
    name: 'Generación de Volantes de Pago',
    component: Volante,
    exact: true,
  },
  {
    to: basePath + '/consultas/manipuladoresdealimentos',
    name: 'Carnet de Manipuladores de Alimentos',
    component: Manipuladores,
    exact: true,
  },
  {
    to: basePath + '/consultas/listadoestablecimientos',
    name: 'Listado de Establecimientos',
    component: Establecimientos,
    exact: true,
  },
  {
    to: basePath + '/consultas/licitacionessalud',
    name: 'Listado de Licitaciones de Salud',
    component: LicitacionesSalud,
    exact: true,
  },
]

export default routes
